import { useMatomo } from "@jonkoops/matomo-tracker-react";

function AdvisoryBoard() {
    const { trackEvent } = useMatomo();

    const boardMembers: boardMembers[] = [
        {
            name: "Florian Wimmer",
            job: "CEO - Blockpit AG",
            position: "Advisor Crypto Tax & Crypto Space",
            image: "/DEMO/images/advisory-1.jpg",
            linkedin: "https://www.linkedin.com/in/florian-wimmer",
            twitter: "https://twitter.com/FlorianWimmerAT%20%20"
        },
        {
            name: "Peter Augustin",
            job: "Founder - Tigris Web3 Fund",
            position: "Advisor Crypto Funds & Web3",
            image: "/DEMO/images/advisory-2.jpg",
            linkedin: "https://www.linkedin.com/in/peter-augustin-293475186/"
        },
        {
            name: "Martin Roy",
            job: "Financial & Leadership Expert",
            position: "Advisor Finance & Global Strategy",
            image: "/DEMO/images/advisory-3.jpg",
            linkedin: "https://www.linkedin.com/in/florian-wimmer",
            xing: "https://www.xing.com/profile/Martin_Roy/cv"
        },
        {
            name: "Franz Großmann",
            job: "IT Infrastructure & Security Expert",
            position: "Advisor Cyber Security & Infrastructure",
            image: "/DEMO/images/advisory-4.jpg",
            linkedin: "https://www.linkedin.com/in/franz-grossmann-schoellernetworkcontrol/"
        }
    ];

    const onSocialMediaClick = (socialMedia: 'linkedin' | 'twitter' | 'xing', name: string) => {
        trackEvent({ category: 'advisory board', action: `${socialMedia} of ${name} clicked` });
    }
    
    return(
        <div className="my-16" id="partners">
            <p className="font-medium text-slate-400">
                Advisory board
            </p>
            <div className="flex flex-row flex-wrap justify-center">
                {boardMembers.map((boardMember, i) => (
                    <div className="flex flex-col items-center m-6 w-1/8" key={"boardMember-" + i}>
                        <img src={boardMember.image} alt="logo" className="my-3 object-contain h-16 border-r-6 rounded-full" key={"boardMemberImage-" + i} />
                        <h2 className="text-slate-800  text-xl font-medium">
                            {boardMember.name}
                        </h2>
                        <p className="font-medium">
                            {boardMember.job}
                        </p>
                        <p className="text-slate-400 w-full">
                            {boardMember.position}
                        </p>
                        <div className="flex flex-row">
                            {
                                boardMember.twitter &&
                                <a href={boardMember.twitter} target="_blank" rel="noreferrer" onClick={() => onSocialMediaClick('twitter', boardMember.name)}>
                                    <img src="/icons/twitter.svg" alt="twitter" height="45px" className="mx-1 mt-3 object-contain hover:brightness-95" key={"boardMemberTwitter-" + i} />
                                </a>
                            }
                            {
                                boardMember.xing &&
                                <a href={boardMember.xing} target="_blank" rel="noreferrer" onClick={() => onSocialMediaClick('xing', boardMember.name)}>
                                    <img src="/icons/xing.svg" alt="xing" height="45px" className="mx-1 mt-3 object-contain hover:brightness-95" key={"boardMemberXing-" + i} />
                                </a>
                            }
                            {
                                boardMember.linkedin &&
                                <a href={boardMember.linkedin} target="_blank" rel="noreferrer" onClick={() => onSocialMediaClick('linkedin', boardMember.name)}>
                                    <img src="/icons/linkedin.svg" alt="linkedin" height="45px" className="mx-1 mt-3 object-contain hover:brightness-95" key={"boardMemberLinkedin-" + i} />
                                </a>
                            }
                        </div>
                    </div>
                ))}
        </div>
    </div>
    )
}

export default AdvisoryBoard;

interface boardMembers {
    name: string;
    job: string;
    position: string;
    image: string;
    twitter?: string;
    linkedin?: string;
    xing?: string;
}